
import $ from 'jquery';

// // header changing color
// $(window).on("scroll",function(){
//     if($(window).scrollTop()>50){
//         $(".navbar").addClass("active");
//     } 
//     else if($(window).scrollTop()>250){
//         $(".navbar").addClass("activeBlue");
//     }
//     else
//     {
//         $(".navbar").removeClass("active");
//         // $(".navbar").removeClass("activeBlue");
//     }
// });

$(window).on("scroll", function () {
    let scroll = $(window).scrollTop();

    if (scroll > 650) {
        $(".navbar").addClass("activeBlue slideDown").removeClass("active");
    } 
    else if (scroll > 50) {
        $(".navbar").addClass("active").removeClass("activeBlue slideDown");
    }
    else {
        $(".navbar").removeClass("active activeBlue slideDown");
    }
});
